/* eslint-disable no-async-promise-executor */
const setJWTTokenInIndexedDB = (token) => new Promise(async (resolve, reject) => {
    // open and save token on indexedDB to get access on sw for
    // notifications (because localStorage is not available on service worker file)
    const request2 = indexedDB.open('notifications');
    request2.onupgradeneeded = (e) => {
        const db = e.target.result; // also available on request.result
        db.createObjectStore('auth', { keyPath: 'name' }); // stores are like tables in indexedDB
    }
    request2.onerror = () => {
        reject();
    }
    request2.onsuccess = (e) => {
        const db = e.target.result; // also available on request.result
        const transaction = db.transaction('auth', 'readwrite');
        const authStore = transaction.objectStore('auth');

        // check if there is a row with token name, update it, otherwise, insert a new one with this name
        authStore.put({ name: 'token', value: token });
        transaction.oncomplete = () => {
            db.close();
            resolve();
        };
        transaction.onerror = (err) => {
            reject(err);
        }
    }
});

export default setJWTTokenInIndexedDB;
